import { Mail, ArrowUp, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-zinc-950 text-white overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg-dark opacity-60" aria-hidden />
      <div
        aria-hidden
        className="absolute -top-40 left-1/2 -translate-x-1/2 w-[800px] h-[500px] rounded-full blur-3xl"
        style={{
          background:
            "radial-gradient(circle at center, rgba(0,102,255,0.25), transparent 60%)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 pt-12 pb-10">
        <div className="grid grid-cols-12 gap-10 pb-12 border-b border-white/10">
          <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center gap-3">
              <span className="inline-block w-2.5 h-2.5 rounded-full bg-[#0066FF] shadow-[0_0_14px_rgba(0,102,255,0.8)]" />
              <span className="font-display text-2xl font-extrabold tracking-[-0.03em] leading-none">
                Laiv Ai
              </span>
            </div>
            <h3 className="font-display mt-6 text-2xl sm:text-3xl lg:text-[2.25rem] font-semibold tracking-[-0.02em] leading-[1.15] text-white max-w-2xl">
              Building technology products that help professionals learn,
              create and work with greater focus.
            </h3>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/50 font-semibold">
              Explore
            </div>
            <ul className="mt-4 space-y-3 text-[15px] text-white/80">
              <li><a className="link-flourish hover:text-white" href="#home" data-testid="footer-link-home">Home</a></li>
              <li><a className="link-flourish hover:text-white" href="#vibecast" data-testid="footer-link-vibecast">Vibecast</a></li>
              <li><a className="link-flourish hover:text-white" href="#vision" data-testid="footer-link-vision">Vision</a></li>
              <li><a className="link-flourish hover:text-white" href="#about" data-testid="footer-link-about">About</a></li>
              <li><a className="link-flourish hover:text-white" href="#contact" data-testid="footer-link-contact">Contact</a></li>
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/50 font-semibold">
              Reach us
            </div>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href="mailto:enterprise@laiv.app"
                  data-testid="footer-email"
                  className="inline-flex items-center gap-2 text-[15px] text-white/85 hover:text-white"
                >
                  <Mail className="w-4 h-4" /> enterprise@laiv.app
                </a>
              </li>
              <li>
                <span
                  data-testid="footer-hq"
                  className="inline-flex items-center gap-2 text-[15px] text-white/70"
                >
                  <MapPin className="w-4 h-4" /> Hyderabad, TS, India
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Compliance disclosure */}
        <div
          data-testid="footer-compliance"
          className="pt-10 grid grid-cols-12 gap-10"
        >
          <div className="col-span-12 lg:col-span-9">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/50 font-semibold">
              Corporate Infrastructure Disclosure
            </div>
            <p className="mt-4 text-[13px] leading-relaxed text-white/70 font-light max-w-4xl">
              © 2026 Laiv Ai Technologies Pvt ltd. All rights reserved. Vibecast is
              a proprietary software platform developed, owned, and distributed
              by Laiv Ai Technologies Pvt ltd. Our global backend media distribution
              engine is architected using high-performance storage buckets,
              adaptive HLS multi-bitrate encoders, and low-latency cloud edge
              distribution delivery networks. Corporate Entity: Laiv Ai Technologies Pvt ltd
              (Hyderabad, TS, India). Enterprise Integration & Vendor
              Contacts:{" "}
              <a
                href="mailto:enterprise@laiv.app"
                className="text-white underline decoration-white/30 hover:decoration-white"
              >
                enterprise@laiv.app
              </a>
              .
            </p>
          </div>

          <div className="col-span-12 lg:col-span-3 flex lg:justify-end items-start">
            <a
              href="#home"
              data-testid="footer-back-to-top"
              className="inline-flex items-center gap-2 text-xs text-white/70 hover:text-white border border-white/15 hover:border-white/40 rounded-full px-4 h-9 transition"
            >
              Back to top
              <ArrowUp className="w-3.5 h-3.5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
